window.addEventListener("load", function () {
  var Page = (function () {

    var config = {
      $bookBlock: $('#bb-bookblock'),
      $navNext: $('#bb-nav-next'),
      $navPrev: $('#bb-nav-prev'),
      $navFirst: $('#bb-nav-first'),
      $navLast: $('#bb-nav-last')
    },
      init = function () {
        config.$bookBlock.bookblock({
          speed: 800,
          shadowSides: 0.8,
          shadowFlip: 0.7
        });
        initEvents();
      },
      initEvents = function () {

        var $slides = config.$bookBlock.children();

        // add navigation events
        config.$navNext.on('click touchstart', function () {
          config.$bookBlock.bookblock('next');
          return false;
        });

        config.$navPrev.on('click touchstart', function () {
          config.$bookBlock.bookblock('prev');
          return false;
        });

        config.$navFirst.on('click touchstart', function () {
          config.$bookBlock.bookblock('first');
          return false;
        });

        config.$navLast.on('click touchstart', function () {
          config.$bookBlock.bookblock('last');
          return false;
        });

        // add swipe events
        $slides.on({
          'swipeleft': function (event) {
            config.$bookBlock.bookblock('next');
            return false;
          },
          'swiperight': function (event) {
            config.$bookBlock.bookblock('prev');
            return false;
          }
        });

        // add keyboard events
        $(document).keydown(function (e) {
          var keyCode = e.keyCode || e.which,
            arrow = {
              left: 37,
              up: 38,
              right: 39,
              down: 40
            };

          switch (keyCode) {
            case arrow.left:
              config.$bookBlock.bookblock('prev');
              break;
            case arrow.right:
              config.$bookBlock.bookblock('next');
              break;
          }
        });
      };

    return { init: init };

  })();
  Page.init();

  Fancybox.bind("[data-fancybox]", {
    Toolbar: false,
    on: {
      done: (fancybox, slide) => {
        console.log("✅ Fancybox done → ảnh đã render");
  
        // 🔒 CHỈ chạy nếu tab-3 đang active
        const tab3 = document.querySelector("#dream-ms-stories .tab-3");
        if (!tab3 || !tab3.classList.contains("active")) {
          console.log("⛔ tab-3 không active → bỏ qua custom download");
          return;
        }
  
        if (!slide || !slide.$content) {
          console.warn("❌ Không có slide hoặc slide.$content");
          return;
        }
  
        // Kiểm tra nếu đã có nút thì bỏ qua
        if (slide.$content.querySelector(".custom-button--download")) return;
  
        // Tạo nút download
        const $btn = document.createElement("button");
        $btn.classList.add("carousel__button", "custom-button--download");
        $btn.title = "Tải xuống";
  
        $btn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm-6 2h12v2H6z"/>
          </svg>
        `;
  
        $btn.addEventListener("click", async () => {
          try {
            const response = await fetch(slide.src, { mode: "cors" });
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = slide.src.split("/").pop() || "image.jpg";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            console.log("⬇ Đã tải:", a.download);
          } catch (err) {
            console.error("❌ Không thể tải hình:", err);
          }
        });
  
        slide.$content.appendChild($btn);
        console.log("✅ Đã gắn nút download");
      }
    }
  });

  var swiper2 = new Swiper(".swiper-tab2", {
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },
    navigation: {
      nextEl: ".swiper-tab2-next",
      prevEl: ".swiper-tab2-prev",
    },
    pagination: {
      el: ".swiper-tab2-pagination",
      clickable: true
    },
  });
  var swiper3 = new Swiper(".swiper-tab3", {
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },
    navigation: {
      nextEl: ".swiper-tab3-next",
      prevEl: ".swiper-tab3-prev",
    },
    pagination: {
      el: ".swiper-tab3-pagination",
      clickable: true
    },
  });
  var swiper4 = new Swiper(".swiper-tab4", {
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },
    navigation: {
      nextEl: ".swiper-tab4-next",
      prevEl: ".swiper-tab4-prev",
    },
    pagination: {
      el: ".swiper-tab4-pagination",
      clickable: true
    },
  });


  // Xử lý click vào các button tab
  $('#dream-ms-stories .list-btns .btn').on('click', function (e) {
    e.preventDefault();

    // Lấy index của button được click (0, 1, 2, 3)
    var index = $(this).index();

    // Remove class active từ tất cả buttons
    $('.list-btns .btn').removeClass('active');

    // Add class active cho button được click
    $(this).addClass('active');

    // Hide tất cả các tabs
    $('[class^="tab-"]').removeClass('active');

    // Show tab tương ứng với button được click
    $('.tab-' + (index + 1)).addClass('active');
  });



});
